import styled from '@emotion/styled'
import { breakWords } from 'component-library/__styling/style-mixins'
import { getSpotifyEmbedHeight } from './helpers/spotify'
import { calcRem } from 'component-library/__styling/style-functions'

export const StyledEmbed = styled('div')<{ embedLink?: string }>(props => {
    const spotifyHeight = getSpotifyEmbedHeight(props.embedLink)
    return {
        clear: 'both',
        margin: calcRem(props.theme.margins.md, 0),
        ...breakWords,

        '&.twitter-embed iframe': {
            width: '100vw!important',
            // DPT-1402: Unsure why this works as it's overwritten by display: block on the iframes
            // inline styles but without this it's broken
            display: 'flex',
        },

        '&.embed iframe': {
            // DPT-1402: Unsure why this works as it's overwritten by display: block on the iframes
            // inline styles but without this it's broken
            display: 'flex',
        },

        '&.spotify-embed': {
            iframe: {
                height: spotifyHeight ? `${spotifyHeight + 31}px` : undefined, // 31 added due to the spotify title from embedly above the iframe (x+31)
            },
        },
    }
})

export const StyledEmbedlyFallback = styled('div')({
    padding: calcRem(5),
    div: {
        marginBottom: calcRem(10),
    },
    '.embed-fallback-desc': {
        fontSize: calcRem(14),
    },
    '.embed-fallback-url': {
        fontSize: calcRem(14),
        color: '#1a95b3',
    },
})
